import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Img } from "@/components/Img";
import { EASE } from "@/components/Motion";

export const ProjectCard = ({ project, index, wide }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, ease: EASE, delay: (index % 2) * 0.08 }}
  >
    <Link
      to={`/portfolio?project=${project.slug}`}
      preventScrollReset
      data-testid={`project-card-${project.slug}`}
      aria-label={`View concept project: ${project.title}`}
      className="group block"
    >
      <div className={`relative overflow-hidden rounded-md bg-mist ${wide ? "aspect-[4/3]" : "aspect-[4/5]"} md:aspect-auto md:h-[26rem] lg:h-[34rem]`}>
        <Img
          name={project.image}
          alt={project.alt}
          sizes={wide ? "(min-width:768px) 58vw, 100vw" : "(min-width:768px) 42vw, 100vw"}
          className="h-full w-full object-cover transition-transform duration-[1400ms] ease-expo group-hover:scale-[1.05]"
        />
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_30%_20%,transparent_40%,rgba(16,33,58,0.35))]" aria-hidden="true" />
        <span className="absolute left-4 top-4 rounded-full bg-paper/95 px-3 py-1.5 font-mono text-[0.65rem] font-medium uppercase tracking-[0.16em] text-navy">
          Concept Project
        </span>
        <span className="absolute bottom-4 right-4 grid h-14 w-14 translate-y-4 place-items-center rounded-full bg-lime text-navy opacity-0 transition-[opacity,transform] duration-500 ease-expo group-hover:translate-y-0 group-hover:opacity-100 group-focus-visible:translate-y-0 group-focus-visible:opacity-100">
          <ArrowUpRight className="h-6 w-6" aria-hidden="true" />
        </span>
      </div>
      <div className="mt-5 flex items-start justify-between gap-6">
        <div>
          <h3 className="font-display text-xl font-bold tracking-tight text-navy transition-colors duration-300 group-hover:text-royal sm:text-2xl">{project.title}</h3>
          <p className="mt-1 text-sm text-slatey">{project.category} · Speculative design</p>
        </div>
        <span className="font-mono text-xs text-slatey">{String(index + 1).padStart(2, "0")}</span>
      </div>
    </Link>
  </motion.div>
);

// Alternating 7/5 column rhythm keeps each row aligned.
export const spanFor = (i) => (i % 4 === 0 || i % 4 === 3 ? "md:col-span-7" : "md:col-span-5");
